"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
window.jQuery = jquery_1.default;
window.$ = jquery_1.default;
jquery_1.default.ajaxSetup({
    cache: false
});
var doc = document;
var root = doc.documentElement || doc;
var $doc = (0, jquery_1.default)(doc);
var $root = (0, jquery_1.default)(root);
var playerUrls = {
    live: '/player/live',
    video: '/player/kijk',
    archief: '/player/archief',
    newsbulletin: '/player/nieuwsbulletin?s_cid=nb-bulletin-homepage'
};
$root.on('click', '.launch-player', function (e) {
    e.preventDefault();
    var el = (0, jquery_1.default)(e.currentTarget);
    var type = el.data('type');
    var audioid = el.data('id');
    var articleid = el.data('articleid');
    var url = playerUrls[type] || playerUrls.live;
    if (audioid) {
        url = "/player/audio/" + audioid + "/" + articleid;
    }
    var playerWindow = window.open(url, "_blank", "width=380,scrollbars=1,height=" + (window.screen.height - 100));
    playerWindow.moveTo(20, 20);
});
$root.on("click", ".show-more,.show-less", function () {
    (0, jquery_1.default)(this).closest('.has-secondary,.filter.collapsible-filter').toggleClass("show-all");
});
$root.on('click', '.show-aside', function () {
    $root.toggleClass('aside-open');
});
$doc.on('click', '[type=checkbox]', function (e) {
    (0, jquery_1.default)(this).closest('.checkbox').toggleClass('checked', this.checked);
});
$doc.on('click', '[type=radio]', function (e) {
    var name = this.getAttribute('name');
    (0, jquery_1.default)('[name=' + name + ']').each(function () {
        (0, jquery_1.default)(this).closest('.radio').toggleClass('checked', this.checked);
    });
});
$root.on('click', '.linkPanel_title', function (e) {
    (0, jquery_1.default)(this).toggleClass('status-open');
});
$doc.on('change', ':radio[name=period]', function (e) {
    $doc.find('.select-period').toggleClass('selected', e.target.value == 'custom-period');
});
$root.on('click', '.header-placeholder .profile-button', function () {
    var header = (0, jquery_1.default)(this).closest('header');
    header.toggleClass('show-profile');
    header.removeClass('show-extra');
    header.removeClass('show-search');
});
setInterval(function () {
    (0, jquery_1.default)('.live-image').attr('src', (0, jquery_1.default)('.live-image').attr('data-src') + '?v=' + (+new Date()));
}, 30000);
